/**
 * Monobank: один black на валюту (дублікати через різний тип currencyCode або злиття списків).
 */
function pickBetterBlackAccount(a, b) {
    const limA = a.creditLimit || 0;
    const limB = b.creditLimit || 0;
    if (limA !== limB) return limA > limB ? a : b;

    const balA = a.balance || 0;
    const balB = b.balance || 0;
    if (balA !== balB) return balA > balB ? a : b;

    const panA = Array.isArray(a.maskedPan) ? a.maskedPan.length : 0;
    const panB = Array.isArray(b.maskedPan) ? b.maskedPan.length : 0;
    if (panA !== panB) return panA > panB ? a : b;

    return a;
}

export function normalizeMonoCurrencyCode(code) {
    if (code === null || code === undefined || code === "") return null;
    const n = Number(code);
    return Number.isFinite(n) ? n : null;
}

const UNKNOWN_CURRENCY_KEY = "__none__";

export function dedupeBlackMonobankAccounts(accounts) {
    if (!Array.isArray(accounts) || accounts.length === 0) return accounts;

    const nonBlack = accounts.filter((a) => a.type !== "black");
    const blacks = accounts.filter((a) => a.type === "black");
    const byCurrency = new Map();

    for (const acc of blacks) {
        const code = normalizeMonoCurrencyCode(acc.currencyCode);
        const key = code === null ? UNKNOWN_CURRENCY_KEY : code;
        const prev = byCurrency.get(key);
        if (!prev) {
            byCurrency.set(key, acc);
        } else {
            byCurrency.set(key, pickBetterBlackAccount(acc, prev));
        }
    }

    return [...nonBlack, ...byCurrency.values()];
}

/**
 * Підпис для чорної картки Mono (UAH): як у застосунку — Використано X з Y ₴.
 */
export function formatBlackCreditUsageUa(account) {
    if (!account || account.type !== "black") return "";
    if (normalizeMonoCurrencyCode(account.currencyCode) !== 980) return "";
    const limit = account.creditLimit;
    if (limit == null || limit <= 0) return "";

    const balance = account.balance || 0;
    const usedKop = Math.max(0, limit - balance);
    const fmt = (kop) =>
        (kop / 100).toLocaleString("uk-UA", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });

    return ` (Використано ${fmt(usedKop)} з ${fmt(limit)} ₴)`;
}
